import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import bannerbg from "../../assets/images/backgrounds/page-header-bg.jpg";
import { useAuth } from "../../context/AuthContext";
import GoogleAuthButton from "../../components/Common/GoogleAuthButton";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const redirect = location.state?.redirect || "/";

  const [form, setForm] = useState({ email: "", password: "" });
  const [status, setStatus] = useState({ state: "idle", message: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ state: "sending", message: "" });
    try {
      const { redirect_to } = await login(form);
      if (redirect_to) {
        // Admin/Organizer/Vendor/Staff — এদের dashboard এখনো Blade-এ, তাই
        // পুরো পেজ hard-redirect (React Router না, কারণ ওটা শুধু React
        // route-এর মধ্যেই কাজ করে)।
        window.location.href = redirect_to;
        return;
      }
      navigate(redirect, { replace: true });
    } catch (err) {
      const errors = err?.response?.data?.errors;
      const message =
        errors?.email?.[0] || err?.response?.data?.message || "Login করা যায়নি। তথ্য আবার চেক করুন।";
      setStatus({ state: "error", message });
    }
  };

  return (
    <React.Fragment>
      <Header parentMenu="login" activeMenu="/login" />
      <SiteBreadcrumb pageTitle="Log in" pageName="Log in" breadcrumbsImg={bannerbg} />

      <section className="contact-one">
        <div className="container">
          <div className="contact-one__inner" style={{ maxWidth: 480, margin: "0 auto" }}>
            <h3 className="contact-one__title">আবার স্বাগতম!</h3>

            {status.state === "error" && (
              <p style={{ color: "#e6394f", marginBottom: 16 }}>{status.message}</p>
            )}

            <form onSubmit={handleSubmit} noValidate>
              <div className="contact-one__input-box">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  required
                />
              </div>
              <div className="contact-one__input-box">
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  required
                />
              </div>

              <div className="contact-one__btn-box">
                <button
                  type="submit"
                  className="thm-btn contact-one__btn"
                  disabled={status.state === "sending"}
                >
                  {status.state === "sending" ? "Logging in..." : "Log in"}
                  <span className="icon-arrow-right"></span>
                </button>
              </div>
            </form>

            <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "22px 0" }}>
              <span style={{ flex: 1, height: 1, background: "#e5e5e5" }} />
              <span style={{ color: "#8a8a8a", fontSize: 13 }}>অথবা</span>
              <span style={{ flex: 1, height: 1, background: "#e5e5e5" }} />
            </div>

            <GoogleAuthButton redirect={redirect} label="Google দিয়ে Log in করুন" />

            <p style={{ marginTop: 20 }}>
              Account নেই? <Link to="/register" state={{ redirect }}>Sign up</Link>
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default Login;
